import React from 'react';
import { Button, Icon } from '@iwoca/orion';
import { Trans } from '@lingui/macro';

import styles from '../Navigation.module.css';

export const SupportDropdown = ({
  toggleDropdown,
}: {
  toggleDropdown: () => void;
}) => {
  return (
    <div className={styles.accountItem}>
      <Button
        variant="tertiary"
        className={styles.navButton}
        onClick={toggleDropdown}
      >
        <Trans>Support</Trans> <Icon icon="angleDown" />
      </Button>
    </div>
  );
};
